import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import CapturePage from "./pages/CapturePage";
import VaultPage from "./pages/VaultPage";
import HomePage from "./pages/HomePage";
import "./index.scss";
import "./index.css";
import AboutPage from "./pages/AboutPage";
import TemplatesPage from "./pages/TemplatesPage";
import EditorPage from "./pages/EditorPage";
import PricingPage from "./pages/PricingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import AboutUsPage from "./pages/AboutUsPage";
import UserPage from "./pages/UserPage";
import { AppProvider } from "./context/AppContext";
import { Toaster } from "./components/ui/sonner";

// Routing entry component
export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <AppRoutes />
        <Toaster />
      </AppProvider>
    </BrowserRouter>
  );
}

// Routes with debug logging
function AppRoutes() {
  const location = useLocation();
  useEffect(() => {}, [location]);
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/editor" element={<EditorPage />} />
      <Route path="/capture" element={<CapturePage />} />
      <Route path="/vault" element={<VaultPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/about-us" element={<AboutUsPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/templates" element={<TemplatesPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/user" element={<UserPage />} />
      <Route path="*" element={<div>404 Not Found</div>} />
    </Routes>
  );
}
